/**
 * Onboarding step definitions.
 *
 * Each step represents a milestone in the farm setup process.
 * Steps are computed dynamically based on current data state.
 */

export type OnboardingStepId =
  | "create-farm"
  | "add-field"
  | "create-animal-group"
  | "assign-field";

export interface OnboardingStep {
  id: OnboardingStepId;
  titleKey: string;
  descriptionKey: string;
  actionKey: string;
  actionRoute: string;
  videoId?: string;
  mobileVideoId?: string;
}

/**
 * Ordered list of onboarding steps.
 * These guide farmers through the complete farm setup process.
 */
export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    id: "create-farm",
    titleKey: "onboarding.step.createFarm.title",
    descriptionKey: "onboarding.step.createFarm.description",
    actionKey: "onboarding.step.createFarm.action",
    actionRoute: "/add-farm/enter-name",
  },
  {
    id: "add-field",
    titleKey: "onboarding.step.addField.title",
    descriptionKey: "onboarding.step.addField.description",
    actionKey: "onboarding.step.addField.action",
    actionRoute: "/add-field/enter-details",
    videoId: "TX0PhAi5Ev4",
    mobileVideoId: "aFYJnHtXBAk",
  },
  {
    id: "create-animal-group",
    titleKey: "onboarding.step.createAnimalGroup.title",
    descriptionKey: "onboarding.step.createAnimalGroup.description",
    actionKey: "onboarding.step.createAnimalGroup.action",
    actionRoute: "/add-animal-group",
    videoId: "OOsbz7l0zsY",
    mobileVideoId: "xZbMXsONPwY",
  },
  {
    id: "assign-field",
    titleKey: "onboarding.step.assignField.title",
    descriptionKey: "onboarding.step.assignField.description",
    actionKey: "onboarding.step.assignField.action",
    // Special route: :animalGroupId will be replaced with actual ID at runtime
    actionRoute: "/animal-group/:animalGroupId?openAssignField=true",
    videoId: "LE3D03GgM8Q",
    mobileVideoId: "EV1WuhI89NM",
  },
];

/**
 * LocalStorage key for onboarding dismissal state.
 */
export const ONBOARDING_DISMISSED_KEY = "ruumi_onboarding_dismissed";
